import { loadStripe, Stripe } from "@stripe/stripe-js";

import constants from "../../constants";

let stripePromise: Promise<Stripe | null> | undefined;

/**
 * Stripe.js, loaded once and only when the checkout needs it (it's a script from js.stripe.com, which Stripe
 * requires instead of bundling it). Resolves to null when there's no publishable key configured.
 */
export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = constants.stripePublishableKey
      ? loadStripe(constants.stripePublishableKey, { locale: "pt-BR" })
      : Promise.resolve(null);
  }
  return stripePromise;
};
